import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import DefaultImageStore from 'images/DefaultImageStore.webp';

export interface CoverImageControlEmptyProps {
    label: string;
    className?: string;
}

const useStyles = makeStyles(theme => ({
    container: {
        backgroundColor: theme.palette.brandPrimary.lightest,
        backgroundImage: `url(${DefaultImageStore})`,
        backgroundSize: 'cover',
        backgroundPositionX: 'center',
        backgroundPositionY: 'center',
        height: '100%',
        textAlign: 'center',
    },
    [theme.breakpoints.up('sm')]: {
        container: {
            borderRadius: 20,
        },
    },
}));

export const CoverImageControlEmpty: FC<CoverImageControlEmptyProps> = ({ className }) => {
    const classes = useStyles();
    return <div className={clsx(classes.container, className)} />;
};
